// extracted by mini-css-extract-plugin
export default {"products":"js-z","card":"ks-z","oosMessaging":"ls-z"};